export default "__VITE_ASSET__DrUDMkjC__"